module.exports = __webpack_public_path__ + "img/banner.7dc9df8.png";